import React from 'react';
import StyleButton from './StyleButton';
import './InlineStyleControls.css';
import {RichUtils} from "draft-js";

const LINK_STYLES = [
  {label: 'Link', style: 'LINK'},
];

class LinkStyleControls extends React.Component {

  render() {
    const { editorState, onToggle } = this.props;

    const containsLink = RichUtils.currentBlockContainsLink(editorState);

    return (
      <span className="RichEditor-controls">
        {LINK_STYLES.map(type =>
          <StyleButton
            key={type.label}
            active={containsLink}
            label={type.label}
            onToggle={onToggle}
            style={type.style}
          />
        )}
      </span>
    );
  }
}

export default LinkStyleControls;
